(function () {
    'use strict';

    angular
        .module('sod.helper')
        .factory('HtmlHelper', HtmlHelper);

    function HtmlHelper() {
        return {
            generateHtmlTag:generateHtmlTag,
            generateAttr: generateAttr
        };

        function generateHtmlTag(tag, attrs) {
            if (!tag) return '';
            return '<' + tag + ' ' + generateAttr(attrs) + '></' + tag + '>';
        }

        function generateAttr(attrs) {
            if (!attrs.length) return "";

            return attrs.map(function(attr) {
                return attr.name + '="' + attr.value + '"';
            }).join(' ');
        }
    }
})();